let queue = []
const isEnabled = () => !!window.fbq

export default {
  allowTracking: false,

  trackEvent(name, params) {
    if (!this.allowTracking) return

    if (!isEnabled()) {
      queue.push({
        type: 'track',
        name,
        params,
      })
      return
    }

    window.fbq('track', name, params)
  },

  trackCustomEvent(name, params) {
    if (!this.allowTracking) return

    if (!isEnabled()) {
      queue.push({
        type: 'trackCustom',
        name,
        params,
      })
      return
    }
    window.fbq('trackCustom', name, params)
  },

  install(installParams) {
    if (!this.allowTracking) return

    const user = installParams.user

    const interval = setInterval(() => {
      if (isEnabled()) {
        clearInterval(interval)
        window.fbq('init', '184099978601650', { em: user.email })
        window.fbq('track', 'PageView')
        queue.forEach(({ type, name, params }) => {
          window.fbq(type, name, params)
        })
        queue = []
      }
    }, 5000)
  },
}
